import LanguagePreference from "./LanguagePreference";
import Greeting from "./Greeting";
import PinCode from "./PinCode";
import DateOfBirth from "./DateOfBirth";
import { useState, useRef } from "react";
import React from "react";
import Consent from "./Consent";
import FaceAndLiveness from "./FaceAndLiveness";
import styled from "styled-components";
import { Header, ProgressBar } from "./components";
import { useNavigate } from "react-router-dom";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  background-color: #f7f7f7;
  font-family: sans-serif;
`;

const OnBoarding = () => {
  const navigate = useNavigate();
  const mediaRecorderRef = useRef(null);
  const recordedChunks = useRef([]);

  const [onboardStepCount, setOnboardStepCount] = useState(1);
  const [recordingStatus, setRecordingStatus] = useState("idle");
  const [isFaceDetected, setIsFaceDetected] = useState(false);
  const [isLivenessDetected, setIsLivenessDetected] = useState(false);

  const handleTakePermissions = () => {
    setOnboardStepCount((prevCount) => prevCount + 1);
  };
  const skipLocation = () => {
    setOnboardStepCount((prevCount) => prevCount + 2);
  };

  const handleProceedWithPassword = () => {
    setOnboardStepCount((prevCount) => prevCount + 1);
  };

  const handleProceedWithPincode = () => {
    setOnboardStepCount((prevCount) => prevCount + 1);
  };

  const handleProceedWithGreetings = () => {
  };

  const handleProceedWithDetails = () => {
    setOnboardStepCount((prevCount) => prevCount + 1);
  };

  const handleFaceAndLiveliness = () => {
    setTimeout(() => {
      setIsFaceDetected(true);

      setTimeout(() => {
        setIsLivenessDetected(true);
      }, 2000);
    }, 1000);
  };

  const handleStartRecording = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({
        video: true,
        audio: true,
      });

      const mediaRecorder = new MediaRecorder(stream);
      mediaRecorderRef.current = mediaRecorder;
      recordedChunks.current = [];

      mediaRecorder.ondataavailable = (event) => {
        if (event.data.size > 0) {
          recordedChunks.current.push(event.data);
        }
      };

      mediaRecorder.onstop = async () => {
        const blob = new Blob(recordedChunks.current, { type: "video/webm" });
        console.log(blob);
        // await sendRecordingToAPI(blob);
      };

      mediaRecorder.start();
      setRecordingStatus("recording");
    } catch (error) {
      console.error("Error accessing media devices:", error);
    }
  };

  const handleStopRecording = () => {
    mediaRecorderRef.current.stop();
    setRecordingStatus("uploading");
    // setTimeout(() => {
    //   navigate("/addBmi");
    // }, 2000);
  };

  // const sendRecordingToAPI = async (blob) => {
  //   console.log("Uploading recording to API...");
  //   const formData = new FormData();
  //   formData.append("file", blob);
  //   try {
  //     console.log(formData);
  //   } catch (error) {
  //     console.error("Error in sending the recording to API:", error);
  //   }
  // };

  const onBoardingData = [
    {
      key: 1,
      component: () => (
        <LanguagePreference
          handlePermission={handleTakePermissions}
          skipLocation={skipLocation}
          handleLanguageChange={() => {}}
        />
      ),
    },

    {
      key: 2,
      component: () => (
        <PinCode onProceedWithPincode={handleProceedWithPincode} />
      ),
    },
    {
      key: 3,
      component: () => (
        <DateOfBirth onProceedWithPassword={handleProceedWithPassword} />
      ),
    },
    {
      key: 4,
      component: () => (
        <Greeting
          onProceedWithGreeting={handleProceedWithGreetings}
          onProceedWithDetails={handleProceedWithDetails}
        />
      ),
    },
    {
      key: 5,
      component: () => (
        <FaceAndLiveness
          isFaceDetected={isFaceDetected}
          isLivenessDetected={isLivenessDetected}
          handleFaceAndLiveliness={handleFaceAndLiveliness}
          handleStartRecording={handleStartRecording}
          handleStopRecording={handleStopRecording}
          recordingStatus={recordingStatus}
        />
      ),
    },
  ];

  const currentPageData = onBoardingData[onboardStepCount - 1];
  // const [videoBlob, setVideoBlob] = useState(null);
  return <Container>{currentPageData?.component()}</Container>;
};

export default OnBoarding;
